import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { tap, takeUntil } from 'rxjs/operators';

@Injectable()
export class CancelRequestsInterceptor implements HttpInterceptor {
  private cancelRequests$ = new Subject<void>();

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(takeUntil(this.cancelRequests$));
  }

  cancelRequests(): void {
    this.cancelRequests$.next();
    this.cancelRequests$.complete();
    this.cancelRequests$ = new Subject<void>();
  }
}
